import { schema } from 'normalizr'
import { insuranceCompany } from './insuranceCompanies'

export const patient = new schema.Entity('patient', {
  insuranceCompany: insuranceCompany,
}, { idAttribute: '_id' })
export const patientArray = new schema.Array(patient)
